<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Reminder</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button
            class="btn add-btn"
            @click="$router.push({ name: 'reminderAdd' })"
          >
            <i class="fa fa-plus"></i>New Reminder
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Filter -->
    <div class="row align-items-center mt-2">
      <div class="col-md-2 fit-content">Reminder Type</div>
      <div class="col-md-4 pl-md-0 fit-content">
        <select class="custom-select" v-model="type">
          <option :value="reminderCarparkClaimApproval">
            {{ reminderCarparkClaimApproval }}
          </option>
          <option :value="reminderTimesheetApproval">
            {{ reminderTimesheetApproval }}
          </option>
          <option :value="reminderFwaApproval">
            {{ reminderFwaApproval }}
          </option>
          <option :value="reminderFwaCancellationApproval">
            {{ reminderFwaCancellationApproval }}
          </option>
        </select>
      </div>
    </div>
    <!-- /Filter -->

    <!-- Pagination -->
    <div class="row mt-4">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <table class="table table-bordered custom-table mb-0">
          <thead class="thead-light">
            <tr>
              <th class="action-column">Action</th>
              <th class="name-column">
                <button class="btn p-0" @click="setSortBy('name')">
                  Name
                  <span class="tableHeaderSortIcon">
                    <i
                      class="fa fa-long-arrow-up ml-3"
                      :style="[
                        paging.SortBy === 'name'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      :style="[
                        paging.SortBy === 'name_desc'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                  </span>
                </button>
              </th>
              <th>
                <button class="btn p-0" @click="setSortBy('reminderDay')">
                  Reminder Days
                  <span class="tableHeaderSortIcon">
                    <i
                      class="fa fa-long-arrow-up ml-3"
                      :style="[
                        paging.SortBy === 'reminderDay'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      :style="[
                        paging.SortBy === 'reminderDay_desc'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                  </span>
                </button>
              </th>
              <th>
                <button class="btn p-0" @click="setSortBy('repeatDay')">
                  Repeat Days
                  <span class="tableHeaderSortIcon">
                    <i
                      class="fa fa-long-arrow-up ml-3"
                      :style="[
                        paging.SortBy === 'repeatDay'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                    <i
                      class="fa fa-long-arrow-down"
                      :style="[
                        paging.SortBy === 'repeatDay_desc'
                          ? { color: 'orange' }
                          : { color: 'white' },
                      ]"
                    ></i>
                  </span>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in records" :key="item.Id">
              <td>
                <label class="toggler">
                  <input
                    type="checkbox"
                    v-model="item.IsActive"
                    @change="toggle(item, $event)"
                  />
                  <span class="slider round"></span>
                </label>
                <router-link
                  v-if="item.IsActive"
                  class="btn mt-2"
                  title="Edit"
                  :to="{
                    name: 'reminderEdit',
                    params: { id: item.Id },
                  }"
                >
                  <i class="fa fa-edit"></i>
                </router-link>
                <button
                  v-if="item.IsActive"
                  class="btn mt-2"
                  title="Delete"
                  @click="remove(item.Id)"
                >
                  <i class="fa fa-trash-o"></i>
                </button>
              </td>
              <td>{{ item.Name }}</td>
              <td>{{ item.ReminderDays }}</td>
              <td>{{ item.RepeatDays }}</td>
            </tr>
            <tr v-if="records && !records.length">
              <td colspan="4" class="text-center">{{ this.noRecordText }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="records && records.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          records.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";

export default {
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      reminderCarparkClaimApproval: config.REMINDER_CAR_PARK_CLAIM_APPROVAL,
      reminderTimesheetApproval: config.REMINDER_TIMESHEET_APPROVAL,
      reminderFwaApproval: config.REMINDER_FWA_APPROVAL,
      reminderFwaCancellationApproval:
        config.REMINDER_FWA_CANCELLATION_APPROVAL,
      type: "",
      records: null,
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  watch: {
    type(val) {
      this.$store.state.reminderType = val;
      this.getReminders(this.type);
    },
    "paging.Search": function (val, oldVal) {
      this.getReminders(this.type);
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getReminders(this.type);
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    toggle(payload, $event) {
      let isActive = $event.target.checked;
      let param = {
        Token: this.token,
        Id: payload.Id,
        IsActive: isActive,
      };
      this.$store.state.isLoading = true;
      API.toggleReminder(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          this.$swal(response.data.message, {
            icon: response.data.success ? "success" : "error",
          });
          if (response.data.success) {
            this.getReminders(this.type);
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    remove(id) {
      let param = {
        Token: this.token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the record?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.deleteReminder(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.getReminders(this.type);
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getReminders(type) {
      let param = {
        Token: this.token,
        Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        Type: type,
      };
      this.$store.state.isLoading = true;
      API.getReminders(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.records = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination method
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getReminders(this.type);
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getReminders(this.type);
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getReminders(this.type);
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getReminders(this.type);
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getReminders(this.type);
    },
    setSortBy(payload) {
      switch (payload) {
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "reminderDay":
          if (this.paging.SortBy === "reminderDay") {
            this.paging.SortBy = "reminderDay_desc";
          } else if (this.paging.SortBy === "reminderDay_desc") {
            this.paging.SortBy = "reminderDay";
          } else {
            this.paging.SortBy = "reminderDay";
          }
          break;
        case "repeatDay":
          if (this.paging.SortBy === "repeatDay") {
            this.paging.SortBy = "repeatDay_desc";
          } else if (this.paging.SortBy === "repeatDay_desc") {
            this.paging.SortBy = "repeatDay";
          } else {
            this.paging.SortBy = "repeatDay";
          }
          break;
      }
      this.getReminders(this.type);
    },
  },

  created() {
    this.type = this.$store.state.reminderType
      ? this.$store.state.reminderType
      : this.reminderCarparkClaimApproval;
    this.getReminders(this.type);
    //access control
    if (this.role != "admin")
      this.$router.replace({ name: "home" });
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}
.action-column {
  width: 15%;
}
.name-column {
  width: 45%;
}
</style>


// WEBPACK FOOTER //
// src/components/System/Reminder/ReminderList.vue